import { AxiosResponse } from "axios";
import axiosConfig from "../../../../../config/axiosConfig";

const AttendanceApi = () => {
  const getAttendanceConstructionMyMemberTimeSheet = async (params: {
    constructionId: number;
    userId: number;
    from: string; // 2006-01-02
    to: string; // 2006-01-02
    timeOffset: number;
  }): Promise<AxiosResponse<any, any>> => {
    const url = "/attendance/construction/my-member/timesheet";
    return await axiosConfig.get(url, { params });
  };
  return { getAttendanceConstructionMyMemberTimeSheet };
};

export default AttendanceApi;
